import React, { useState, useEffect } from 'react';
import './ProfilPicture.css';
import translations from '../../utils/language/translations.json';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ImageSelector from '../../utils/icon/ImageSelector';

function ProfilePicture({ currentPicture, userId }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(currentPicture || null);
  const [isUploading, setIsUploading] = useState(false);

  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.ProfilPicture[key][currentLang];

  useEffect(() => {
    setPreviewImage(currentPicture || null);
  }, [currentPicture]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageDataUrl = e.target.result;
        setSelectedImage(file);
        setPreviewImage(imageDataUrl);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSaveImage = async () => {
    if (!selectedImage) {
      toast.error(t("No image selected."));
      return;
    }

    setIsUploading(true);

    const formData = new FormData();
    formData.append("image", selectedImage); // ✅ Send file instead of Base64

    try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE}/Profil/updateProfilPicture/${userId}`, {
            method: 'PUT',
            credentials: 'include',
            body: formData, // ✅ Send FormData directly
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Failed to update profile picture');

        setPreviewImage(data.imageUrl); // ✅ Update with new S3 URL
        setSelectedImage(null); // ✅ Reset selected image
        toast.success(t('Profile picture updated successfully!'));
    } catch (error) {
        console.error("❌ Error:", error);
        toast.error(`Error: ${error.message}`);
    } finally {
        setIsUploading(false);
    }
  };

  const handleCancelImage = () => {
    setSelectedImage(null);
    setPreviewImage(currentPicture || null);
    toast.info(t("Image selection canceled."));
  };

  const handleSelectImageClick = () => {
    document.getElementById('fileInput').click();
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '20vh',
      }}
    >
      <h2>{t('Edit your profile')}</h2>
      <input
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        style={{ display: 'none' }}
        
        id="fileInput"
      />
      {previewImage && (
        <div className="profile-picture-preview">
          <img
            src={previewImage}
            alt="Selected Profile Picture"
            className="profile-picture"
          />
        </div>
      )}
      {/* <button onClick={handleSelectImageClick}>
        {t('Select a new profile picture')} <ImageSelector />
      </button> */}
      {selectedImage ? (<>
        <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
          <button onClick={handleSaveImage}>
            {t('Save')}
          </button>
          <button onClick={handleCancelImage}>
            {t('Cancel')}
          </button>
        </div>
        </> ) : (<> <button onClick={handleSelectImageClick} className='btn-baseBlue' style={{width: 'fit-content', marginTop: '10px'}}>
        {t('Select a new profile picture')} <ImageSelector />
      </button></>)}
      {isUploading && <div className="loading-spinner">Uploading...</div>}
    </div>
  );
}

export default ProfilePicture;
